import { render } from "./AlertAccountNotActivated.vue?vue&type=template&id=90a8cc2c"
import script from "./AlertAccountNotActivated.vue?vue&type=script&lang=js"
export * from "./AlertAccountNotActivated.vue?vue&type=script&lang=js"

import "./AlertAccountNotActivated.vue?vue&type=style&index=0&id=90a8cc2c&lang=scss"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__